module.exports = __webpack_public_path__ + "static/media/Drizzle.ffb909c8.svg";